import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { safeAnchorHref } from '../../../lib/link';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from '../ensigns/focus-ring';
import { SpecraText } from '../ensigns/typography';
/** Compact product breadcrumbs for the persistent program top bar. */ export const SpecraBreadcrumbs = /*#__PURE__*/ React.forwardRef(({ className, items, label = 'Breadcrumb', linkComponent: LinkComponent, renderLink, ...props }, ref)=>/*#__PURE__*/ _jsx("nav", {
        "aria-label": label,
        className: cn('min-w-0', className),
        ref: ref,
        ...props,
        children: /*#__PURE__*/ _jsx("ol", {
            className: "flex min-w-0 items-center gap-2",
            children: items.map((item, index)=>{
                const fallbackHref = item.href ? safeAnchorHref(item.href) : undefined;
                const interactive = Boolean(fallbackHref || item.onClick || item.href && (renderLink || LinkComponent));
                const linkClassName = cn('truncate bg-transparent p-0 text-[length:var(--fs-ui-caption)]', item.current ? 'font-medium text-foreground' : 'text-muted-foreground', interactive && `cursor-pointer hover:text-foreground ${specraFocusRing}`);
                const Component = fallbackHref ? 'a' : item.onClick ? 'button' : 'span';
                const interactiveProps = fallbackHref ? {
                    href: fallbackHref,
                    onClick: item.onClick
                } : item.onClick ? {
                    onClick: item.onClick,
                    type: 'button'
                } : {};
                return /*#__PURE__*/ _jsxs("li", {
                    className: "flex min-w-0 items-center gap-2",
                    children: [
                        index > 0 ? /*#__PURE__*/ _jsx(SpecraText, {
                            "aria-hidden": "true",
                            tone: "muted",
                            children: "/"
                        }) : null,
                        item.href && renderLink ? renderLink({
                            'aria-current': item.current ? 'page' : undefined,
                            children: item.label,
                            className: linkClassName,
                            'data-testid': item.testId,
                            'data-item-id': item.id,
                            href: item.href,
                            onClick: item.onClick
                        }) : item.href && LinkComponent ? /*#__PURE__*/ _jsx(LinkComponent, {
                            "aria-current": item.current ? 'page' : undefined,
                            className: linkClassName,
                            "data-testid": item.testId,
                            "data-item-id": item.id,
                            onClick: item.onClick,
                            to: item.href,
                            children: item.label
                        }) : /*#__PURE__*/ _jsx(Component, {
                            "aria-current": item.current ? 'page' : undefined,
                            className: linkClassName,
                            "data-testid": item.testId,
                            "data-item-id": item.id,
                            ...interactiveProps,
                            children: item.label
                        })
                    ]
                }, item.id);
            })
        })
    }));
SpecraBreadcrumbs.displayName = 'SpecraBreadcrumbs';
